/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Lutely API
 * Lutely API
 * OpenAPI spec version: local
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CreateTrackProcessOnDemandDto,
  TrackMinDto,
  TrackProcessControllerTrackProcessList200,
  TrackProcessControllerTrackProcessListParams,
  TrackProcessControllerTrackProcessRetryParams,
} from ".././dtos";

import { apiRequest } from "../../api-request";
import type { ErrorType, BodyType } from "../../api-request";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Create a track process on demand
 */
export const trackProcessControllerTrackProcessCreate = (
  createTrackProcessOnDemandDto: BodyType<CreateTrackProcessOnDemandDto>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    {
      url: `/track-processes`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createTrackProcessOnDemandDto,
      signal,
    },
    options,
  );
};

export const getTrackProcessControllerTrackProcessCreateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackProcessControllerTrackProcessCreate>>,
    TError,
    { data: BodyType<CreateTrackProcessOnDemandDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackProcessControllerTrackProcessCreate>>,
  TError,
  { data: BodyType<CreateTrackProcessOnDemandDto> },
  TContext
> => {
  const mutationKey = ["trackProcessControllerTrackProcessCreate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackProcessControllerTrackProcessCreate>>,
    { data: BodyType<CreateTrackProcessOnDemandDto> }
  > = (props) => {
    const { data } = props ?? {};

    return trackProcessControllerTrackProcessCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TrackProcessControllerTrackProcessCreateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof trackProcessControllerTrackProcessCreate>>
  >;
export type TrackProcessControllerTrackProcessCreateMutationBody =
  BodyType<CreateTrackProcessOnDemandDto>;
export type TrackProcessControllerTrackProcessCreateMutationError =
  ErrorType<unknown>;

/**
 * @summary Create a track process on demand
 */
export const useTrackProcessControllerTrackProcessCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof trackProcessControllerTrackProcessCreate>>,
      TError,
      { data: BodyType<CreateTrackProcessOnDemandDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackProcessControllerTrackProcessCreate>>,
  TError,
  { data: BodyType<CreateTrackProcessOnDemandDto> },
  TContext
> => {
  const mutationOptions =
    getTrackProcessControllerTrackProcessCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary List track processes
 */
export const trackProcessControllerTrackProcessList = (
  params?: TrackProcessControllerTrackProcessListParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<TrackProcessControllerTrackProcessList200>(
    { url: `/track-processes`, method: "GET", params, signal },
    options,
  );
};

export const getTrackProcessControllerTrackProcessListQueryKey = (
  params?: TrackProcessControllerTrackProcessListParams,
) => {
  return [`/track-processes`, ...(params ? [params] : [])] as const;
};

export const getTrackProcessControllerTrackProcessListQueryOptions = <
  TData = Awaited<ReturnType<typeof trackProcessControllerTrackProcessList>>,
  TError = ErrorType<unknown>,
>(
  params?: TrackProcessControllerTrackProcessListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackProcessControllerTrackProcessList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTrackProcessControllerTrackProcessListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof trackProcessControllerTrackProcessList>>
  > = ({ signal }) =>
    trackProcessControllerTrackProcessList(params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof trackProcessControllerTrackProcessList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type TrackProcessControllerTrackProcessListQueryResult = NonNullable<
  Awaited<ReturnType<typeof trackProcessControllerTrackProcessList>>
>;
export type TrackProcessControllerTrackProcessListQueryError =
  ErrorType<unknown>;

export function useTrackProcessControllerTrackProcessList<
  TData = Awaited<ReturnType<typeof trackProcessControllerTrackProcessList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | TrackProcessControllerTrackProcessListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackProcessControllerTrackProcessList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackProcessControllerTrackProcessList>>,
          TError,
          Awaited<ReturnType<typeof trackProcessControllerTrackProcessList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useTrackProcessControllerTrackProcessList<
  TData = Awaited<ReturnType<typeof trackProcessControllerTrackProcessList>>,
  TError = ErrorType<unknown>,
>(
  params?: TrackProcessControllerTrackProcessListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackProcessControllerTrackProcessList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackProcessControllerTrackProcessList>>,
          TError,
          Awaited<ReturnType<typeof trackProcessControllerTrackProcessList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTrackProcessControllerTrackProcessList<
  TData = Awaited<ReturnType<typeof trackProcessControllerTrackProcessList>>,
  TError = ErrorType<unknown>,
>(
  params?: TrackProcessControllerTrackProcessListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackProcessControllerTrackProcessList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List track processes
 */

export function useTrackProcessControllerTrackProcessList<
  TData = Awaited<ReturnType<typeof trackProcessControllerTrackProcessList>>,
  TError = ErrorType<unknown>,
>(
  params?: TrackProcessControllerTrackProcessListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackProcessControllerTrackProcessList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getTrackProcessControllerTrackProcessListQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const trackProcessControllerTrackProcessRetry = (
  params: TrackProcessControllerTrackProcessRetryParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    { url: `/track-processes/retry`, method: "POST", params, signal },
    options,
  );
};

export const getTrackProcessControllerTrackProcessRetryMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackProcessControllerTrackProcessRetry>>,
    TError,
    { params: TrackProcessControllerTrackProcessRetryParams },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackProcessControllerTrackProcessRetry>>,
  TError,
  { params: TrackProcessControllerTrackProcessRetryParams },
  TContext
> => {
  const mutationKey = ["trackProcessControllerTrackProcessRetry"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackProcessControllerTrackProcessRetry>>,
    { params: TrackProcessControllerTrackProcessRetryParams }
  > = (props) => {
    const { params } = props ?? {};

    return trackProcessControllerTrackProcessRetry(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TrackProcessControllerTrackProcessRetryMutationResult = NonNullable<
  Awaited<ReturnType<typeof trackProcessControllerTrackProcessRetry>>
>;

export type TrackProcessControllerTrackProcessRetryMutationError =
  ErrorType<unknown>;

export const useTrackProcessControllerTrackProcessRetry = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof trackProcessControllerTrackProcessRetry>>,
      TError,
      { params: TrackProcessControllerTrackProcessRetryParams },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackProcessControllerTrackProcessRetry>>,
  TError,
  { params: TrackProcessControllerTrackProcessRetryParams },
  TContext
> => {
  const mutationOptions =
    getTrackProcessControllerTrackProcessRetryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary List ongoing track processes for all creators of the authenticated user
 */
export const trackProcessControllerTrackProcessOngoing = (
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<TrackMinDto[]>(
    { url: `/track-processes/ongoing`, method: "GET", signal },
    options,
  );
};

export const getTrackProcessControllerTrackProcessOngoingQueryKey = () => {
  return [`/track-processes/ongoing`] as const;
};

export const getTrackProcessControllerTrackProcessOngoingQueryOptions = <
  TData = Awaited<ReturnType<typeof trackProcessControllerTrackProcessOngoing>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof trackProcessControllerTrackProcessOngoing>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof apiRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTrackProcessControllerTrackProcessOngoingQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof trackProcessControllerTrackProcessOngoing>>
  > = ({ signal }) =>
    trackProcessControllerTrackProcessOngoing(requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof trackProcessControllerTrackProcessOngoing>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type TrackProcessControllerTrackProcessOngoingQueryResult = NonNullable<
  Awaited<ReturnType<typeof trackProcessControllerTrackProcessOngoing>>
>;
export type TrackProcessControllerTrackProcessOngoingQueryError =
  ErrorType<unknown>;

export function useTrackProcessControllerTrackProcessOngoing<
  TData = Awaited<ReturnType<typeof trackProcessControllerTrackProcessOngoing>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackProcessControllerTrackProcessOngoing>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackProcessControllerTrackProcessOngoing>>,
          TError,
          Awaited<ReturnType<typeof trackProcessControllerTrackProcessOngoing>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useTrackProcessControllerTrackProcessOngoing<
  TData = Awaited<ReturnType<typeof trackProcessControllerTrackProcessOngoing>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackProcessControllerTrackProcessOngoing>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackProcessControllerTrackProcessOngoing>>,
          TError,
          Awaited<ReturnType<typeof trackProcessControllerTrackProcessOngoing>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTrackProcessControllerTrackProcessOngoing<
  TData = Awaited<ReturnType<typeof trackProcessControllerTrackProcessOngoing>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackProcessControllerTrackProcessOngoing>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List ongoing track processes for all creators of the authenticated user
 */

export function useTrackProcessControllerTrackProcessOngoing<
  TData = Awaited<ReturnType<typeof trackProcessControllerTrackProcessOngoing>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackProcessControllerTrackProcessOngoing>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getTrackProcessControllerTrackProcessOngoingQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
